import React, { memo, forwardRef } from 'react';
import cn from 'classnames';
import { Box } from '../box';
import { useSlot } from './hooks';
import { useColor } from '../../hooks/useColor';
import styles from './styles.module.css';
export const Lead = memo(forwardRef(function Lead({ children, size, ...props }, ref) {
    const { sizeClass, widthClass, elRef, context } = useSlot({ size, ref });
    return (React.createElement(Box, { ref: elRef, ...props, className: cn(styles.lead, sizeClass, widthClass, props.className, {
            [styles.noTrailingPadding]: !!context.noTrailingPadding,
        }) }, children));
}));
const Icon = memo(forwardRef(function Icon({ color = 'main', className, children, ...rest }, ref) {
    const colorClass = useColor(color);
    const { widthClass } = useSlot();
    return (React.createElement(Lead, { ...rest, ref: ref, className: cn(className, styles.icon, widthClass, colorClass) }, children));
}));
export const Leads = {
    Icon,
};
